import types from '../types/types';

const initialState = {
  InfoCarrito: [],
  IdCarrito: 0,
};
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.addTocart:
      return {
        ...state,
        InfoCarrito: action.InfoCarrito,
        IdCarrito: action.IdCarrito,
      };
    case types.getCart:
      return {
        ...state,
        InfoCarrito: action.InfoCarrito,
        IdCarrito: action.IdCarrito,
      };

    default:
      return state;
  }
};
export default cartReducer;
